import { BACKGROUND_VIDEO_PATH } from "../../constants/path";
import styles from "./LoginBackground.module.less";

const LoginBackground = () => {
  return (
    <>
      <video className={styles.bgVideo} loop muted autoPlay>
        <source src={BACKGROUND_VIDEO_PATH} type="video/mp4" />
      </video>

      <div className={styles.loginBackgroundImage}>
        <div className={styles.sideLoginImage} />
      </div>
    </>
  );
};

export default LoginBackground;
